import React from 'react';

export default function Exhausted() {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.iconWrap}>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="24" fill="#FFF0F3" />
            <path d="M16 24h16M24 16v8" stroke="#FA1C51" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M14 32c0-5.5 4.5-10 10-10s10 4.5 10 10" stroke="#FA1C51" strokeWidth="2" strokeLinecap="round" strokeDasharray="3 2" />
          </svg>
        </div>
        <h2 style={styles.title}>内容已全部发放</h2>
        <p style={styles.desc}>本次活动的内容已被领取完毕</p>
        <p style={styles.desc2}>请联系工作人员获取更多内容</p>
      </div>
      <div style={styles.brand}>
        <img src="/favicon.png" alt="券宝宝" style={styles.logo} />
        <span style={styles.brandName}>券宝宝</span>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    background: '#f7f7f8', padding: '32px 24px',
  },
  card: {
    background: '#fff', borderRadius: 20, padding: '40px 32px',
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    boxShadow: '0 4px 24px rgba(0,0,0,0.07)', width: '100%', maxWidth: 320,
  },
  iconWrap: { marginBottom: 24 },
  title: { fontSize: 20, fontWeight: 700, color: '#111', margin: '0 0 10px', textAlign: 'center' },
  desc:  { fontSize: 15, color: '#666', textAlign: 'center', margin: '0 0 4px', lineHeight: 1.6 },
  desc2: { fontSize: 14, color: '#999', textAlign: 'center', margin: 0 },
  brand: { display: 'flex', alignItems: 'center', gap: 6, marginTop: 32, opacity: 0.5 },
  logo:  { width: 20, height: 20, borderRadius: 5 },
  brandName: { fontSize: 13, color: '#666' },
};
